<template>
  <div>
    <v2-row noSpace>
      <v2-col col12 noSpaceX style="height: 400px" class="relative">
        <div :class="['mt-0 h-full v2-backoffice-uppy']" :id="'trigger-envivo-upload-box-' + component.uid"></div>
        <v2-uppy-upload
          :withMediaLibraryButton="true"
          :id="component.uid"
          :locale="teams[$route.params.team].account.locale"
          :target="'#trigger-envivo-upload-box-' + component.uid"
          componentTagname="tb-file-list"
          :inline="true"
          :hideUploadButton="true"
          :create-file="createNewFile"
          :uploadConfig="uploadConfig"
          @completed="createRelation"
          @openMediaLibrary="openMediaLibrary"
        ></v2-uppy-upload>
      </v2-col>
    </v2-row>
    <v2-row noSpace>
      <v2-col col12 noSpace noSpaceX>
        <form @submit.prevent class="w-full flex items-center relative">
          <v2-textfield
            :label="$t('quickLaunch.labels.addLabel')"
            v-model="fileListLabel"
            name="fileListLabel"
            @input="validateLabel()"
          ></v2-textfield>
          <v2-button
            :title="$t('quickLaunch.actions.addLabel')"
            :active="!addLabelDisabled"
            class="absolute mb-2.5"
            style="right: 10px"
            secondary
            icon
            sm
            @click.native="addLabel"
          >
            <v2-icon :data="require('@icon/Icon=check.svg')"></v2-icon>
          </v2-button>
        </form>
      </v2-col>
      <v2-col col12 noSpace noSpaceX v-if="fileList && fileList.length > 0">
        <v2-draggable
          v-model="fileList"
          @start="drag = true"
          @end="drag = false"
          v-bind="dragOptions"
          @change="changeOrder"
        >
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <ql-file-list-item
              @reload="reloadComponent"
              v-for="file in fileList"
              :key="file.uid"
              :component="component"
              :file="file"
            ></ql-file-list-item>
          </transition-group>
        </v2-draggable>
      </v2-col>
    </v2-row>
  </div>
</template>

<script>
import QlFileListItem from "./QuickLaunchFileListItem";
import teamAbilities from "@/mixins/teamAbilities.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "QuickLaunchFileList",
  components: {
    QlFileListItem,
  },
  mixins: [teamAbilities],
  props: {
    component: Object,
  },
  data() {
    return {
      dragOptions: {
        animation: 200,
        group: "files",
        disabled: false,
        ghostClass: "ghost",
        handle: ".handle",
      },
      uploadConfig: {
        max_files: -1,
      },
      fileList: null,
      fileListLabel: "",
      drag: false,
      addLabelDisabled: true,
    };
  },
  created() {
    this.fileList = this.component.relations;
    this.uploadConfig.max_size = this.teamUploadConfig().max_size;
    this.$eventbus.$on("closeMediaLibrary", this.handleMediaLibrarySelector);
  },
  destroyed() {
    this.$eventbus.$off("closeMediaLibrary");
  },
  methods: {
    ...mapActions([
      "getProjectComponent",
      "createComponentRelation",
      "createComponentLabel",
      "createProjectFiles",
      "sortComponentRelations",
    ]),
    validateLabel() {
      this.fileListLabel !== "" ? (this.addLabelDisabled = false) : (this.addLabelDisabled = true);
    },
    createNewFile(data) {
      return new Promise((resolve, reject) => {
        var vm = this;
        data.params.project = this.currentProject.uid;
        data.params.component = this.component.uid;
        data.customLoading = true;
        vm.createProjectFiles(data)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            vm.$snotify.error(vm.$t("quickLaunch.toasts.uploadFile.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
            reject(err);
          });
      });
    },
    createRelation(data) {
      const vm = this;
      const d = {
        customLoading: true,
        params: {
          project: this.currentProject.uid,
          component: this.component.uid,
        },
        data: {
          type: data.type ? data.type : "projectfile",
          uid: data.uid,
        },
      };
      vm.createComponentRelation(d)
        .then(() => {
          vm.$snotify.success(vm.$t("quickLaunch.toasts.uploadFile.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
          vm.reloadComponent();
        })
        .catch(() => {
          vm.$snotify.error(vm.$t("quickLaunch.toasts.uploadFile.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
        });
    },
    openMediaLibrary() {
      const data = {
        component: this.component.uid,
        files: this.fileList,
      };
      this.$eventbus.$emit("openMediaLibrary", data);
    },
    handleMediaLibrarySelector(data) {
      if (data.component === this.component.uid) {
        console.log("handleMediaLibrarySelector", data);
        data.selected.forEach((file) => {
          this.createRelation({ uid: file, type: "libraryfile" });
        });
      }
    },
    reloadComponent() {
      this.getProjectComponent({
        customLoading: true,
        params: {
          project: this.currentProject.uid,
          component: this.component.uid,
        },
      }).then((res) => {
        this.fileList = res.relations;
      });
    },
    addLabel() {
      if (!this.addLabelDisabled) {
        const vm = this;
        const data = {
          customLoading: true,
          params: {
            project: this.currentProject.uid,
            component: this.component.uid,
          },
          data: {
            text: this.fileListLabel,
          },
        };
        vm.createComponentLabel(data)
          .then(() => {
            vm.$snotify.success(vm.$t("quickLaunch.toasts.createLabel.success"), vm.$t("toasts.success"), {
              icon: vm.$successIcon,
            });
            vm.reloadComponent();
            vm.fileListLabel = "";
          })
          .catch(() => {
            vm.$snotify.error(vm.$t("quickLaunch.toasts.createLabel.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          });
      }
    },
    changeOrder(e) {
      const movedElement = e.moved.element.relationUid;
      const previousElementIndex = e.moved.newIndex - 1 > -1 ? e.moved.newIndex - 1 : null;
      const previousElement = previousElementIndex !== null ? this.fileList[previousElementIndex].relationUid : null;
      const data = {
        customLoading: true,
        params: {
          project: this.currentProject.uid,
          component: this.component.uid,
        },
        data: {
          drag: movedElement,
          after: previousElement,
        },
      };
      const vm = this;
      vm.sortComponentRelations(data)
        .then(() => {
          vm.$snotify.success(vm.$t("quickLaunch.toasts.moveItem.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
        })
        .catch(() => {
          vm.$snotify.error(vm.$t("quickLaunch.toasts.moveItem.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      currentProject: "projects_get_current_project",
    }),
  },
  watch: {
    component: {
      deep: true,
      handler: function () {
        const vm = this;
        vm.$nextTick(() => {
          vm.fileList = vm.component.relations;
        });
      },
    },
  },
};
</script>

<style lang="scss">
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  @apply bg-v2-grey-locked;
}
</style>
